import {Picker} from "../../Utils/Picker";
import React from "react";

export default function RateCardPicker({options, value, label, disabled, editable, setEditable, blank, onChange, onSave, inlineEdit}){

    return (
        <Picker
            name={"rate_card"}
            options={options}
            value={value}
            label={label}
            disabled={disabled}
            editable={editable}
            setEditable={setEditable}
            blank={blank}
            onSave={onSave}
            onChange={onChange}
            inlineEdit={inlineEdit}
            optionField={"name"}
        />
    )

}